import { render, staticRenderFns } from "./vuecommeqzk.vue?vue&type=template&id=8cc46676&scoped=true"
import script from "./vuecommeqzk.vue?vue&type=script&lang=js"
export * from "./vuecommeqzk.vue?vue&type=script&lang=js"
import style0 from "./vuecommeqzk.vue?vue&type=style&index=0&id=8cc46676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc46676",
  null
  
)

export default component.exports